module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable05.97d870c7.png";